import { render, staticRenderFns } from "./SwapInput.vue?vue&type=template&id=49941d3d&scoped=true"
import script from "./SwapInput.vue?vue&type=script&lang=ts"
export * from "./SwapInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49941d3d",
  null
  
)

export default component.exports